//Helpers
import { stringifyLocalAction } from '../ui/local_actions_view_helpers';
//Types
import type { Device } from 'src/types/Device';
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const getLocalActionURL = (url: string, device: Device): string => {
	return stringifyLocalAction(getURLParams(url), device);
};

export const setURLParams = (action: ActionJob, ip = '127.0.0.1'): string => {
	if (/^blutrv.(target|boost|position)$/.test(action?.method)) {
		return `http://${ip}/rpc/blutrv.call?a2=1&id=${action.params.id}&method=${action.method.replace(
			'blutrv.',
			'trv.set',
		)}&params=${encodeURIComponent(JSON.stringify({ ...action.params, id: 0 }))}`;
	}
	let url = `http://${ip}/rpc/${action.method}?a2=1`;
	for (const k in action.params) {
		let p = action.params[k];
		if (p != null) {
			if (typeof p === 'object') {
				p = JSON.stringify(p);
			}
			url += `&${k}=${p}`;
		}
	}
	return encodeURI(url);
};

export const getURLParams = (url: string): ActionJob => {
	const action: ActionJob = {
			method: url.match(/\/rpc\/([^\?]+)/)?.[1] || '',
			params: {},
		},
		params = {},
		decode = (value: string) => {
			try {
				return decodeURIComponent(value);
			} catch (e) {
				return value;
			}
		};
	url.replace(/[?&]+([^=&]+)=([^&]*)/gi, (_m, k, value) => (params[k] = decode(value)));
	for (const k in params) {
		let param = params[k];
		if (!/^(\s*|null|undefined)$/.test(param)) {
			if (k == 'rgb') {
				// Parse RGB array and convert to numbers [0-255]
				param = param
					.replace(/\[|\]/g, '')
					.split(',')
					.map((v) => {
						const num = Number(v.trim());
						return isNaN(num) ? 0 : Math.max(0, Math.min(255, num));
					});
			} else if (/^(true|false)$/.test(param)) param = /^true$/.test(param);
			else if (!isNaN(param)) param = Number(param);
			action.params[k] = parseJsonURLParams(param);
		}
	}
	if (action.method == 'blutrv.call') {
		action.method = action.params.method.replace('trv.set', 'blutrv.');
		action.params = action.params.params;
	}
	return action;
};

export const parseJsonURLParams = (param: string): any => {
	try {
		return JSON.parse(param?.replace(/(\s+|\/)/g, ''));
	} catch (e) {
		return param;
	}
};
